const baseURL = 'http://mitienda.appboutique.click/';

export default baseURL;
